import React from "react";

export const Completed = () => {
    return (
        <div></div>
    )
}